import * as THREE from 'three';
import { Group, Mesh } from 'three';
import store from '../store';
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
import { PathGeometry, PathPointList } from 'three.path';
// 格式化线上的点
const getPointList = (points) => {
    let bgPointList = [];
    points.forEach((point, i) => {
        bgPointList = bgPointList.concat([point[0], point[1], point[2]]);
    });
    return bgPointList;
};
// 获取一段距离的随机点位
function rand(m, n) {
    return Math.ceil(Math.random() * (n - m + 1) + m - 1);
}
class myPath {
    pointsArr;
    pointPercentArr;
    line;
    preUp; // 上次方向
    perce;
    speed;
    turnFactor;
    turnSpeedFactor;
    flowingLineTexture;
    curve;
    model;
    progress = 0.15; // 物体运动时在运动路径的初始位置，范围0~1
    velocity = 0.005; // 影响运动速率的一个值，范围0~1，需要和渲染频率结合计算才能得到真正的速率
    obj;
    preTime;
    firstTurn;
    lineType = '';
    pathPoints = [];
    pathCurve = [];
    constructor(camera, array, speed, linewidth, percePosition, cycle, lineType) {
        // 将传进来的数组转换为Vec3集合
        const pointsArr = [];
        const arrayLength = array.length;
        for (let index = 0; index < arrayLength; index += 3) {
            pointsArr.push(new THREE.Vector3(array[index], array[index + 1], array[index + 2]));
        }
        this.pointsArr = pointsArr;
        const realDistanceArr = []; // 每段距离
        let realSumDistance = 0; // 总距离
        for (let index = 0; index < this.pointsArr.length - 1; index++) {
            realDistanceArr.push(this.pointsArr[index].distanceTo(this.pointsArr[index + 1]));
        }
        realSumDistance = realDistanceArr.reduce(function (tmp, item) {
            return tmp + item;
        });
        // 将传进来的数组转换为Vec3集合
        this.progress = percePosition;
        this.lineType = lineType;
        const realTime = realSumDistance / speed;
        this.velocity = this.velocity / (realTime / 100) * 2;
        const mapImage = require(`@blade-sxp/map/src/assets/${lineType}.png`);
        // 加载纹理
        this.flowingLineTexture = new THREE.TextureLoader().load(mapImage);
        // // 贴图在水平方向上允许重复
        this.flowingLineTexture.wrapS = THREE.RepeatWrapping;
        if (lineType === 'Pulse' || lineType === 'Full line') {
            this.flowingLineTexture.repeat.set(0.01, 1);
        }
        this.curve = new THREE.CatmullRomCurve3(pointsArr);
        const path = this.curve.getPoints(25);
        this.pointsArr = pointsArr;
        // 传入顶点坐标数据
        const path2d = [];
        path.forEach((item) => {
            path2d.push(item.x, item.y, item.z);
        });
        const up = new THREE.Vector3(0, 0, 1);
        // 创建材质
        const material = new THREE.MeshPhongMaterial({
            map: this.flowingLineTexture,
            transparent: true,
            depthWrite: false,
            emissive: new THREE.Color(0x3295FB),
        });
        this.pathPoints = new PathPointList();
        this.pathCurve = new THREE.CatmullRomCurve3(pointsArr, false, 'catmullrom', 0);
        // 设置集合属性
        this.pathPoints.set(pointsArr, 0.5, 2, up, false);
        // 创建 geometry
        const geometry = new PathGeometry();
        geometry.update(this.pathPoints, {
            width: 5 * linewidth,
            arrow: false
        });
        this.line = new Mesh(geometry, material);
        // 计算每个锚点在整条折线上所占的百分比
        this.pointPercentArr = [];
        {
            const distanceArr = []; // 每段距离
            let sumDistance = 0; // 总距离
            for (let index = 0; index < this.pointsArr.length - 1; index++) {
                distanceArr.push(this.pointsArr[index].distanceTo(this.pointsArr[index + 1]));
            }
            sumDistance = distanceArr.reduce(function (tmp, item) {
                return tmp + item;
            });
            const disPerSumArr = [0];
            disPerSumArr.push(distanceArr[0]);
            distanceArr.reduce(function (tmp, item) {
                disPerSumArr.push(tmp + item);
                return tmp + item;
            });
            disPerSumArr.forEach((value, index) => {
                disPerSumArr[index] = value / sumDistance;
            });
            this.pointPercentArr = disPerSumArr;
        }
        // 上一次的朝向 todo
        this.preUp = new THREE.Vector3(0, 0, 0);
        // run函数需要的数据
        this.perce = percePosition; // 控制当前位置占整条线百分比
        this.speed = 0.0005 * speed; // 控制是否运动
        this.turnFactor = 0; // 暂停时间因子
        this.turnSpeedFactor = 0.1; // 转向速度因子
        this.obj = null;
        this.preTime = new Date().getTime();
        this.firstTurn = false;
    }
    // 获取点，是否转弯，朝向等
    getPoint(percent) {
        let indexP = 0;
        let indexN = 0;
        let turn = false;
        // length提取 todo
        const pointLength = this.pointPercentArr.length;
        for (let i = 0; i < pointLength; i++) {
            if (percent >= this.pointPercentArr[i] && percent < this.pointPercentArr[i + 1]) {
                indexN = i + 1;
                indexP = i;
                if (percent === this.pointPercentArr[i]) {
                    turn = true;
                }
            }
        }
        const factor = (percent - this.pointPercentArr[indexP]) / (this.pointPercentArr[indexN] - this.pointPercentArr[indexP]);
        const position = new THREE.Vector3();
        position.lerpVectors(this.pointsArr[indexP], this.pointsArr[indexN], factor); // position的计算完全正确
        // 计算朝向
        const up = new THREE.Vector3().subVectors(this.pointsArr[indexN], this.pointsArr[indexP]);
        const preUp = this.preUp;
        if (this.preUp.x !== up.x || this.preUp.y !== up.y || this.preUp.z !== up.z) {
            // 当前朝向与上次朝向不等，将turn置为true
            turn = true;
        }
        this.preUp = up;
        return {
            position,
            direction: up,
            turn,
            preUp // 当需要转向时的上次的方向
        };
    }
    // 物体沿线移动方法
    async moveOnCurve(model, modelType) {
        if (this.lineType !== 'Full line') {
            this.flowingLineTexture.offset.x -= 0.05;
        }
        if (this.curve == null || model == null) {
            // console.log("Loading");
        }
        else {
            if (this.progress <= 1 - this.velocity) {
                const point = this.pathCurve.getPointAt(this.progress); // 获取样条曲线指定点坐标
                const pointBox = this.pathCurve.getPointAt(this.progress + this.velocity); // 获取样条曲线指定点坐标
                if (point && pointBox) {
                    model.position.set(point.x, point.y, point.z);
                    // 因为这个模型加载进来默认面部是正对Z轴负方向的，所以直接lookAt会导致出现倒着跑的现象，这里用重新设置朝向的方法来解决。
                    const targetPos = pointBox; // 目标位置点
                    // //以下代码在多段路径时可重复执行
                    const mtx = new THREE.Matrix4(); // 创建一个4维矩阵
                    // .lookAt ( eye : Vector3, target : Vector3, up : Vector3 ) : this,构造一个旋转矩阵，从eye 指向 target，由向量 up 定向。
                    mtx.lookAt(model.position, targetPos, model.up); // 设置朝向
                    mtx.multiply(new THREE.Matrix4().makeRotationFromEuler(modelType === 'Person' ? new THREE.Euler(0, 0, 0) : new THREE.Euler(1.54, 1.54, 0)));
                    const toRot = new THREE.Quaternion().setFromRotationMatrix(mtx); // 计算出需要进行旋转的四元数值
                    model.quaternion.slerp(toRot, 1); // 应用旋转。0.2代表插值step。可以做到平滑旋转过渡
                }
                this.progress += this.velocity;
            }
            else {
                this.progress = 0;
            }
        }
    }
    // 参数：是否运动，运动的对象，是否运动到结尾
    run(camera, modelType) {
        if (this.lineType !== 'Full line') {
            this.flowingLineTexture.offset.x -= 0.05;
        }
        // 转弯时
        if (this.obj && this.obj.turn) {
            if (this.turnFactor === 0) {
                this.preTime = new Date().getTime();
                this.turnFactor += 0.000000000000000000000001;
            }
            else {
                const nowTime = new Date().getTime();
                const timePass = nowTime - this.preTime;
                this.preTime = nowTime;
                this.turnFactor += this.turnSpeedFactor * timePass;
            }
            // console.log('--->>> 当前需要turn , turnFactor值为 :', this.turnFactor);
            if (this.turnFactor > 1) {
                this.turnFactor = 0;
                this.perce += this.speed;
                this.obj = this.getPoint(this.perce);
            }
            else {
                const interDirec = new THREE.Vector3();
                interDirec.lerpVectors(this.obj.preUp?.clone().normalize(), this.obj.direction.clone().normalize(), this.turnFactor);
                if (modelType === 'Car') {
                    // 车模型转动方向
                    camera.lookAt(this.obj.position.clone().add(interDirec.clone()));
                    const v1 = interDirec.clone().cross(new THREE.Vector3(0, 0, 1)).normalize();
                    const v2 = interDirec.clone().cross(v1).normalize();
                    camera.rotateOnWorldAxis(v1, Math.PI / 2);
                    camera.rotateOnWorldAxis(v2, Math.PI / 2);
                }
                else {
                    let look = new THREE.Vector3();
                    look = look.add(this.obj.position);
                    look = look.add(interDirec);
                }
            }
        }
        else {
            this.obj = this.getPoint(this.perce);
            // 修改位置
            const posi = this.obj.position;
            const interDirec = new THREE.Vector3();
            interDirec.lerpVectors(this.obj.preUp?.clone().normalize(), this.obj.direction.clone().normalize(), this.turnFactor);
            if (modelType === 'Car') {
                // 车模型转动方向
                camera.lookAt(this.obj.position.clone().add(interDirec.clone()));
                const v1 = interDirec.clone().cross(new THREE.Vector3(0, 0, 1)).normalize();
                const v2 = interDirec.clone().cross(v1).normalize();
                camera.rotateOnWorldAxis(v1, Math.PI / 2);
                camera.rotateOnWorldAxis(v2, Math.PI / 2);
                // cone.position.set(posi.x, posi.y, posi.z);
            }
            camera.position.set(posi.x, posi.y, posi.z); // 相机漫游2
            // 当不需要转向时进行
            if (!this.obj.turn) {
                const look = posi.add(this.obj.direction);
                // cone.lookAt(look);
                // camera.lookAt(look); // 相机漫游3
            }
            this.perce += this.speed;
        }
    }
    dispose() {
        this.line?.material?.dispose();
        this.line?.geometry?.dispose();
        this.line?.remove?.();
    }
}
class Path2D extends Group {
    props;
    cone = new THREE.Mesh();
    coneArr = [];
    allCone = [];
    prePropsStr = '';
    dom;
    name = '';
    path = null;
    animateId = -1;
    constructor(data) {
        super();
        this.props = data;
        this.name = this.uuid;
        // 初始化
        this.update(data);
    }
    dispose(isTemp = false) {
        this.cone = '';
        this.coneArr = [];
        this.allCone = [];
        this.dom = '';
        const imgs = document.getElementsByClassName('pathImg');
        imgs && imgs.length && Array.from(imgs)?.forEach((img) => {
            img.remove();
        });
        this.traverse(obj => {
            if (obj instanceof THREE.Mesh) {
                obj.geometry.dispose();
                obj.material.dispose();
            }
            if (obj.parent && !isTemp) {
                obj?.parent.remove(obj);
            }
            obj.clear();
            const coverMesh = obj.getObjectByName('coverMesh');
            coverMesh?.parent?.remove?.(coverMesh);
            coverMesh?.clear();
        });
        if (!isTemp) {
            this.clear();
            this.parent?.remove(this);
            window.cancelAnimationFrame(this.animateId);
            this.name = '';
            if (this.props?.onDestory && typeof this.props?.onDestory === 'function') {
                this.props?.onDestory(this);
            }
        }
    }
    setHTML(html) {
        if (html) {
            this.dom = html;
        }
        else {
            const img = document.createElement('img');
            img.src = this.props?.renderProps?.covering?.name || '';
            img.setAttribute('width', '30');
            img.className = 'pathImg';
            img.style.top = '-10px';
            this.dom = img;
        }
        return this.dom;
    }
    async setCarHTML(pointOne, pointTwo) {
        await new Promise((resolve, reject) => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const image = new Image();
            image.src = require('@blade-sxp/map/src/assets/bottomcar.png');
            image.onload = () => {
                const scale = 10;
                canvas.width = image.width * scale;
                canvas.height = image.height * scale;
                ctx?.clearRect(0, 0, canvas.width, canvas.height);
                ctx?.drawImage(image, 0, 0, canvas.width, canvas.height);
                // 矩形平面
                const geometry = new THREE.PlaneGeometry(canvas.width / 10, canvas.height / 10);
                const texture = new THREE.CanvasTexture(canvas);
                const material = new THREE.MeshBasicMaterial({
                    map: texture,
                    side: THREE.DoubleSide,
                    transparent: true,
                    depthTest: false
                });
                texture.needsUpdate = true;
                const mesh = new THREE.Mesh(geometry, material).clone();
                this.dom = mesh;
                resolve(this.dom);
            };
        });
    }
    // 初始化线条和点
    async update(data) {
        const currentPropsStr = JSON.stringify(data);
        if (this.prePropsStr !== currentPropsStr) {
            this.prePropsStr = currentPropsStr;
        }
        else {
            return;
        }
        this.dispose(true);
        this.props = data;
        this.name = this.uuid;
        // 反向
        if (this.props?.renderProps?.cycle) {
            this.props?.renderProps?.points?.reverse();
        }
        const _that = this;
        const material = new THREE.MeshBasicMaterial({ color: 15245878, side: THREE.DoubleSide });
        const geometry = new THREE.BoxGeometry(0, 5, 6);
        geometry.rotateX(Math.PI / 2);
        const coverring = this.props?.renderProps.coveringCount || 1;
        // 获取数据进行计算出每个点位所在位置占总线段的百分比
        const array = [];
        const newArr = [];
        for (let index = 0; index < coverring; index++) {
            array.push((index + 1) * (1 / coverring));
        }
        if (this.props?.renderProps?.covering?.key === 'Car') {
            await this.setCarHTML(this.props?.renderProps?.points[0], this.props?.renderProps?.points[1]);
        }
        // 获取任意两点的随机数
        array.map((item, index) => {
            if (index < array.length - 1) {
                newArr.push(rand(array[index] * 100, array[index + 1] * 100) / 100);
            }
        });
        // 首点为起点
        newArr.unshift(0);
        // 获取画线的点 
        const arrayPoints = getPointList(this.props?.renderProps?.points);
        // new path 创建路径
        this.allCone.forEach((cone) => {
            cone.geometry.dispose();
            cone.material.dispose();
            cone.remove();
            if (cone.parent) {
                cone?.parent.remove(cone);
            }
            cone.clear();
        });
        array.forEach((item, index) => {
            const cone = this.props?.renderProps?.covering?.key === 'Car' ? this.dom.clone() : new THREE.Mesh(geometry, material.clone());
            if (this.props?.renderProps?.covering?.key !== 'Car') {
                const htmlMesh = new CSS2DObject(this.setHTML());
                htmlMesh.name = 'coverMesh';
                cone.add(htmlMesh);
            }
            cone.isObserver = true;
            this.coneArr.push(cone.uuid);
            this.allCone.push(cone);
            if (this.props?.renderProps.coveringCount > 0) {
                cone.name = 'coverMesh';
                this.add(cone);
            }
            this.path?.dispose();
            // eslint-disable-next-line new-cap
            const pathLine = new myPath(store?.camera, arrayPoints, this.props?.renderProps.speed, 3 * this.props?.renderProps.width, item, this.props?.renderProps?.cycle, this.props?.renderProps?.type); // 后期需要数据对接
            // 添加点和路径
            const runMesh = cone;
            _that.cone = this.allCone[0];
            if (index === 0) {
                pathLine.line.name = 'pathLine';
                this.add(pathLine.line);
                pathLine.line.visible = this.props?.renderProps.show;
            }
            this.path = pathLine;
            const animate = () => {
                this.animateId = requestAnimationFrame(animate);
                // if (this.props?.renderProps?.type === 'Pulse') {
                //   (pathLine.line.material as any).uniforms.offset.value.x -= 0.01;
                // } else {
                //   (pathLine.line.material as any).uniforms.offset.value.x -= 0.001;
                // }
                if (!store?.camera || !store?.controls)
                    return;
                // pathLine.run(runMesh as THREE.Mesh as unknown as never, this.props?.renderProps?.covering?.key);
                pathLine.moveOnCurve(cone, this.props?.renderProps.covering?.key);
                // 路程循环
                // if (pathLine.perce >= 1) {
                //   pathLine.perce = 0;
                // }
            };
            animate();
        });
    }
}
// 底线
export default Path2D;
